<template>
  <b-form @submit.prevent="send()">

    <b-row class="form-group" v-if="user.role.code === constants.EJECUTIVO_CUENTA || service_code === constants.DEVOLUCIONES">
      <label class="col-sm-2 col-form-label">Cliente</label>
      <div class="col-sm-5">
        <v-select
          v-model="company"
          :value="company.id"
          :options="companies"
          label="name"
        ></v-select>
      </div>
    </b-row>

    <b-row class="form-group">
      <label class="col-sm-2 col-form-label">Línea naviera</label>
      <div class="col-sm-5">
        <v-select
          v-if="!id"
          v-model="shipping_line"
          :value="service.shipping_line_id"
          :options="shipping_lines"
          label="name"
          :on-change="setShippingLine"
        ></v-select>
        <p v-else>{{rq.service.shipping_line.name}}</p>
      </div>
    </b-row>

    <b-row class="form-group" v-if="service_code === constants.POSICIONAMIENTOS">
      <label class="col-sm-2 col-form-label">Nave</label>
      <div class="col-sm-5">
        <input type="text" v-model="service.ship_name" v-if="!id" required class="form-control"/>
        <span v-else>{{rq.service.ship_name}}</span>
      </div>
    </b-row>

    <b-row class="form-group" v-if="service_code === constants.POSICIONAMIENTOS">
      <label class="col-sm-2 col-form-label">CUTOFF</label>
      <div class="col-sm-5">
        <date-picker
          v-if="!id"
          v-model="service.cutoff"
          lang="es"
          type="datetime"
          format="DD/MM/YYYY HH:mm"
          :time-picker-options="{ start: '00:00', step: '00:30', end: '23:55' }"
        ></date-picker>
        <span v-else>{{rq.service.cutoff | formatDateTime}}</span>
      </div>
    </b-row>

    <b-row class="form-group">
      <label class="col-sm-2 col-form-label">
        {{ service_code === constants.POSICIONAMIENTOS ? 'Booking' : 'BL/BK'}}</label>
      <div class="col-sm-5">
        <input type="text" v-model="service.doc_number" v-if="!id" class="form-control"/>
        <span v-else>{{rq.service.doc_number}}</span>
      </div>
    </b-row>

    <b-row class="form-group" v-if="service_code === constants.POSICIONAMIENTOS">
      <label class="col-sm-2 col-form-label">Embarcador</label>
      <div class="col-sm-5">
        <input type="text" v-model="service.owner_name" required v-if="!id" class="form-control"/>
        <span v-else>{{rq.service.owner_name}}</span>
      </div>
    </b-row>

    <b-row v-if="!id" class="form-group">
      <label class="col-sm-2 col-form-label">Cantidad de contenedores</label>
      <div class="col-sm-5 mb-3 input-group">
        <input type="number" v-model="qty" class="form-control"/>
        <!-- Sólo para reentregas y devoluciones -->
        <div class="input-group-append" v-if="service_code !== constants.POSICIONAMIENTOS">
          <button class="btn btn-primary" type="button" @click="addContainers()">Agregar</button>
        </div>
      </div>
    </b-row>

    <b-row v-else class="form-group">
      <label class="col-sm-2 col-form-label">Número de contenedor</label>
      <div class="col-sm-5">
        <input type="text" v-model="rq.container_number" class="form-control"/>
      </div>
    </b-row>

    <b-row class="form-group" v-if="service_code === constants.POSICIONAMIENTOS || id">
      <label class="col-sm-2 col-form-label">Tipo de contenedor</label>
      <div class="col-sm-5">
        <select v-model="rq.container_size_id" required class="form-control">
          <option
            v-for="(container_size,k) in container_sizes"
            :key="k"
            :value="container_size.id">
            {{container_size.name}}
          </option>
        </select>
      </div>
    </b-row>

    <b-row class="form-group">
      <label class="col-sm-2 col-form-label">Terminal de retiro</label>
      <div class="col-sm-5">
        <select
          v-model="rq.deposit_pick_id"
          class="form-control"
          :disabled="[constants.DEVOLUCIONES].includes(this.service_code)"
          required
        >
          <option v-for="(depot, k) in deposits_pick" :key="k" :value="depot.id">{{depot.name}}</option>
        </select>
      </div>
    </b-row>

    <b-row class="form-group">
      <label class="col-sm-2 col-form-label">Terminal de entrega</label>
      <div class="col-sm-5">
        <select
          v-model="rq.deposit_id"
          class="form-control"
          :disabled="service_code === constants.POSICIONAMIENTOS"
        >
          <option v-for="(depot, k) in deposits" :key="k" :value="depot.id">{{depot.name}}</option>
        </select>
      </div>
    </b-row>

    <b-row class="form-group">
      <label
        class="col-sm-2 col-form-label"
      >{{service_code === constants.POSICIONAMIENTOS ? 'Fecha de retiro en Depot' : 'Fecha y horario de entrega'}}</label>
      <div class="col-sm-5">
        <date-picker
          v-model="rq.date"
          lang="es"
          type="datetime"
          required
          format="DD/MM/YYYY HH:mm"
          :time-picker-options="{ start: '00:00', step: '00:30', end: '23:55' }"
        ></date-picker>
      </div>
    </b-row>

    <b-row class="form-group" v-if="service_code === constants.POSICIONAMIENTOS">
      <label class="col-sm-2 col-form-label">Fecha de llenado</label>
      <div class="col-sm-5">
        <date-picker
          v-model="rq.date_fill"
          lang="es"
          type="datetime"
          required
          format="DD/MM/YYYY HH:mm"
          :time-picker-options="{ start: '00:00', step: '00:30', end: '23:55' }"
        ></date-picker>
      </div>
    </b-row>

    <b-row class="form-group" v-if="service_code === constants.POSICIONAMIENTOS">
      <label class="col-sm-2 col-form-label"></label>
      <div class="col-sm-5">
        <input type="checkbox" v-model="rq.inspection"/> Inspección
      </div>
    </b-row>

    <b-row class="form-group" v-if="service_code === constants.POSICIONAMIENTOS">
      <label class="col-sm-2 col-form-label"></label>
      <div class="col-sm-5">
        <input type="checkbox" v-model="rq.lined"/> Forrado
      </div>
    </b-row>

    <b-row class="form-group" v-if="!id && service_code === constants.POSICIONAMIENTOS">
      <label class="col-sm-2 col-form-label">Carta de precinto</label>
      <div class="col-sm-5">
        <input type="file" ref="letter" @change="previewLetter"/>
      </div>
    </b-row>

    <b-row class="form-group" v-if="!id && service_code === constants.POSICIONAMIENTOS">
      <label class="col-sm-2 col-form-label">Booking</label>
      <div class="col-sm-5">
        <input type="file" ref="booking" @change="previewBooking"/>
      </div>
    </b-row>

    <b-row class="form-group" v-if="service_code !== constants.POSICIONAMIENTOS && !id">
      <div class="col-sm-7">
        <table class="table table-bordered">
          <thead>
          <th>Contenedor</th>
          <th>Tamaño contenedor</th>
          </thead>
          <tbody>
          <tr v-for="(container, k) in containers" :key="k">
            <td><input type="text" class="form-control" v-model="container.container_number"></td>
            <td>
              <select v-model="container.container_size_id" class="form-control">
                <option v-for="(size, s) in container_sizes" :key="s" :value="size.id">{{size.name}}</option>
              </select>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </b-row>

    <div slot="footer">
      <input type="submit" class="btn btn-primary" value="Enviar"/>
    </div>
  </b-form>
</template>

<script>
  import api from "@/helpers/api";
  import VueTagsInput from "@johmun/vue-tags-input";
  import moment from "moment";
  import constants from "@/constants";
  import {mapGetters} from "vuex";

  export default {
    components: {VueTagsInput},
    props: ["void", "id"],
    data() {
      return {
        service: {},
        qty: 0,
        rq: {service: {shipping_line: {}}},
        doc_seal: null,
        doc_booking: null,
        constants: {},
        container_sizes: [],
        deposits: [],
        deposits_pick: [],
        shipping_lines: [],
        shipping_line: {},
        text: "",
        containers: [],
        container: {},
        service_code: this.getServiceCode(),
        company: {},
        companies: []
      };
    },
    computed: {
      ...mapGetters({
        user: "user/user"
      })
    },
    mounted() {
      this.constants = constants;

      if (this.id) {
        api.get(`/requeriment/${this.id}`).then(response => {
          this.rq = response.requeriment;
        });
      }
      //comentario
      if (this.user.role.code === constants.EJECUTIVO_CUENTA || this.service_code === constants.DEVOLUCIONES) {
        api.get("/companies").then(response => {
          this.companies = response.companies;
        });
      }


      api.get("/deposits").then(response => {
        if (this.service_code === constants.REENTREGAS) {
          this.deposits_pick = response.deposits;
          this.deposits = response.deposits;
        } else if (this.service_code == constants.POSICIONAMIENTOS) {
          this.deposits = response.deposits;
          this.deposits_pick = response.deposits.filter(dp => !dp.positioning);
          this.rq.deposit_id = response.deposits.find(dp => dp.positioning).id;
        } else if (this.service_code === constants.DEVOLUCIONES) {
          this.deposits_pick = response.deposits;
          this.deposits = response.deposits.filter(dp => !dp.devolution);
          this.rq.deposit_pick_id = response.deposits.find(
            dp => dp.devolution
          ).id;
        }
      });

      api.get("/shipping_lines").then(response => {
        this.shipping_lines = response.shipping_lines;
      });

      api.get("/container_sizes").then(response => {
        this.container_sizes = response.container_sizes;
      });

      // this.addContainers()
    },
    methods: {
      addContainers() {

        for (let i = 0; i < this.qty; i++) {
          let container = {
            container_number: '',
            container_size_id: ''
          }
          this.containers.push(container)
        }
        console.log("TOTAL CONTENEDORES: ", this.containers.length)
      },
      setShippingLine(obj) {
        this.shipping_line = obj ? obj : {};
        this.service.shipping_line_id = obj ? obj.id : null;
      },
      getServiceCode() {
        let service_code = null;
        switch (this.void) {
          case "redeliveries":
            service_code = constants.REENTREGAS;
            break;
          case "devolutions":
            service_code = constants.DEVOLUCIONES;
            break;
          case "positioning":
            service_code = constants.POSICIONAMIENTOS;
            break;
        }
        return service_code;
      },
      previewLetter() {
        this.doc_seal = this.$refs.letter.files[0];
      },
      previewBooking() {
        this.doc_booking = this.$refs.booking.files[0];
      },
      validations() {
        let result = true;
        if (this.qty < 1) {
          this.$toastr.warning(
            "Debes indicar al menos 1 contenedor",
            "Traslado de vacíos",
            {
              positionClass: "toast-top-center",
              closeButton: true
            }
          );
          result = false;
        }

        if (!this.service.shipping_line_id) {
          this.$toastr.warning(
            "Debes indicar linea naviera",
            "Traslado de vacíos",
            {
              positionClass: "toast-top-center",
              closeButton: true
            }
          );
          result = false;
        }

        if (!this.rq.date || !moment(this.rq.date).isValid()) {
          this.$toastr.warning(
            `Fecha de ${
              this.service_code === constants.POSICIONAMIENTOS
                ? "retiro"
                : "operación"
            } inválida`,
            "Traslado de vacíos",
            {
              positionClass: "toast-top-center",
              closeButton: true
            }
          );
          result = false;
        }

        if (this.service_code === constants.POSICIONAMIENTOS) {
          if (this.rq.date_fill && !moment(this.rq.date_fill).isValid()) {
            this.$toastr.warning(
              "Fecha de llenado inválida",
              "Traslado de vacíos",
              {
                positionClass: "toast-top-center",
                closeButton: true
              }
            );
            result = false;
          }
          if (!this.service.cutoff || !moment(this.service.cutoff).isValid()) {
            this.$toastr.warning("Fecha cutoff inválida", "Traslado de vacíos", {
              positionClass: "toast-top-center",
              closeButton: true
            });
            result = false;
          }
          if (!this.doc_booking) {
            this.$toastr.warning(
              "Documento booking obligatorio",
              "Traslado de vacíos",
              {
                positionClass: "toast-top-center",
                closeButton: true
              }
            );
            result = false;
          }
        }
        return result;
      },
      send() {
        if (this.id) {
          let data = {
            deposit_id: this.rq.deposit_id,
            deposit_pick_id: this.rq.deposit_pick_id,
            container_number: this.rq.container_number,
            container_size_id: this.rq.container_size_id,
            date: moment(this.rq.date).format("YYYY-MM-DD HH:mm:00"),
            date_fill: moment(this.rq.date_fill).isValid() ? moment(this.rq.date_fill).format("YYYY-MM-DD HH:mm:00") : null,
            inspection: this.rq.inspection,
            lined: this.rq.lined,
            admin: true
          };

          api.put(`/requeriments/${this.id}`, data).then(response => {
            this.$toastr.success(
              "Actualizado exitosamente",
              "Traslado de vacíos",
              {
                positionClass: "toast-top-center",
                closeButton: true
              }
            );
          });
        } else {
          let formData = new FormData();

          if (this.service_code) {
            if (this.validations()) {
              (this.service.service_code = this.service_code),
                (this.service.cutoff = moment(this.service.cutoff).format(
                  "YYYY-MM-DD HH:mm:ss"
                ));

              if (this.service_code == constants.POSICIONAMIENTOS) {
                for (let i = 0; i < this.qty; i++) {

                  this.containers.push({
                    deposit_id: this.rq.deposit_id,
                    deposit_pick_id: this.rq.deposit_pick_id,
                    date: moment(this.rq.date).format("YYYY-MM-DD HH:mm:ss"),
                    date_fill: moment(this.rq.date_fill).format(
                      "YYYY-MM-DD HH:mm:ss"
                    ),
                    inspection: this.rq.inspection,
                    lined: this.rq.lined,
                    container_size_id: this.rq.container_size_id
                  });

                }
              } else {
                this.containers.map(ctn => {
                  ctn.date = moment(this.rq.date).format("YYYY-MM-DD HH:mm:ss")
                  ctn.deposit_id = this.rq.deposit_id
                  ctn.deposit_pick_id = this.rq.deposit_pick_id
                  return ctn
                })

                if (this.containers.some(ctn => !ctn.container_size_id)) {
                  this.$toastr.error(
                    "Debes indicar el tamaño de todos los contenedores",
                    "Traslado de vacíos",
                    {
                      positionClass: "toast-top-center",
                      closeButton: true
                    }
                  );
                  return false
                }
              }

              if (this.containers.length == 0) {
                this.$toastr.error(
                  "Debes ingresar al menos 1 contenedor",
                  "Traslado de vacíos",
                  {
                    positionClass: "toast-top-center",
                    closeButton: true
                  }
                );
                return false
              }

              console.log(this.containers)
              // return false

              this.service.requeriments = this.containers;

              //cuando es ejecutivo cuenta se setea el company
              if ( [constants.EJECUTIVO_CUENTA, constants.EJECUTIVO_COMERCIAL, constants.SUPERVISOR_VACIOS].includes(this.user.role.code)) {
                this.service.company_id = this.company.id
              }

              if (this.doc_seal) formData.append("doc_seal", this.doc_seal);
              if (this.doc_booking)
                formData.append("doc_booking", this.doc_booking);

              formData.append("service", JSON.stringify(this.service));


              api
                .post("/void", formData, {
                  headers: {"Content-Type": "multiplart/form-data"}
                })
                .then(response => {
                  this.$toastr.success(
                    "Registrado exitosamente",
                    "Traslado de vacíos",
                    {
                      positionClass: "toast-top-center",
                      closeButton: true
                    }
                  );
                });
            }
          } else {
            this.$toastr.error(
              "Ocurrio un error. Inténtalo nuevamente",
              "Traslado de vacíos",
              {
                positionClass: "toast-top-center",
                closeButton: true
              }
            );
          }
        }
      }
    }
  };
</script>
